// Shared result-sound mapping for Dice (used by scene + tests).
import { getSoundManager } from './sound-manager.js';

export function playResultSound(matchCount: number, multiplier: number): void {
  const sm = getSoundManager();
  if (matchCount === 0) {
    sm.play('result.lose');
    return;
  }
  if (multiplier >= 4) sm.play('result.win.large');
  else if (multiplier >= 3) sm.play('result.win.medium');
  else sm.play('result.win.small');
}
